var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerIconWhite = function SvgHamburgerIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.084 8.167v-1.75h19.833v1.75zm0 13.416v-1.75h19.833v1.75zm0-6.708v-1.75h19.833v1.75z"
  })));
};
export { SvgHamburgerIconWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0iTTQuMDgzNSA4LjE2NjY3VjYuNDE2NjdIMjMuOTE2OFY4LjE2NjY3SDQuMDgzNVpNNC4wODM1IDIxLjU4MzNWMTkuODMzM0gyMy45MTY4VjIxLjU4MzNINC4wODM1Wk00LjA4MzUgMTQuODc1VjEzLjEyNUgyMy45MTY4VjE0Ljg3NUg0LjA4MzVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=";